import axios from 'axios';
import { createMutation } from 'react-query-kit';

import { restUrl } from '@/services/utils';
import { ServerErrorResponse } from '@/types/ServerErrorResponse';

import { BulkSearch } from './bulkSearch.types';

const END_POINT = 'bulkSearch';

/** Angular `ErrorCode.BULK_SEARCH_STILL_ACTIVE`. */
export const ERROR_CODE_BULK_SEARCH_STILL_ACTIVE = 401;

/** Angular `ErrorCode.BULK_SEARCH_LONG_VALUE`. */
export const ERROR_CODE_BULK_SEARCH_LONG_VALUE = 402;

interface CreateBulkSearchVariables {
    name: string;
    attributeName: string;
    exactSearch: boolean;
    searchValues: string[];
}

export const useCreateBulkSearch = createMutation<
    BulkSearch,
    CreateBulkSearchVariables,
    ServerErrorResponse
>({
    mutationFn: async ({ name, attributeName, exactSearch, searchValues }) => {
        const response = await axios.post<BulkSearch>(
            restUrl(END_POINT),
            searchValues,
            { params: { name, attributeName, exactSearch } },
        );
        return response.data;
    },
});

export async function fetchBulkSearch(bulkSearchId: string | number): Promise<BulkSearch> {
    const response = await axios.get<BulkSearch>(restUrl(`${END_POINT}/${bulkSearchId}`));
    return response.data;
}
